import { render, staticRenderFns } from "./MicroaudienceDifference.vue?vue&type=template&id=f276ba7e&"
import script from "./MicroaudienceDifference.vue?vue&type=script&lang=js&"
export * from "./MicroaudienceDifference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports